'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Autoplay, Pagination } from 'swiper/modules';
import { Heading } from '../shared/heading';

import { GoArrowRight } from 'react-icons/go';

export const MemberSwiper = ({ members }: { members: TDynamicData[] }) => {
  return (
    <Swiper
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      loop={true}
      pagination={true}
      modules={[Pagination, Autoplay]}
      className={cn('mySwiper', 'ea-member-swiper', 'h-full w-full')}
      slidesPerView={1}
      spaceBetween={0}
    >
      {members.map(member => {
        const title_before_name = member.fields[0]?.value;
        //const first_name = member.fields[1]?.value;
        //const surname = member.fields[2]?.value;
        const title_after_name = member.fields[3]?.value;
        //const role = member.fields[4]?.value;

        return (
          <SwiperSlide
            key={member.slug}
            className="relative flex w-full items-center justify-center pb-16 pt-[180px] sm:pt-[250px] lg:pb-[250px]"
          >
            <Image
              src="/images/symbol.svg"
              alt="Zákon"
              height={0}
              width={0}
              unoptimized
              className="absolute left-1/2 top-1/2 z-[3] h-[300px] w-[150px] -translate-x-1/2 -translate-y-1/2"
            />
            <div className={cn('custom-container', 'relative z-[5] mx-auto')}>
              <div className="ml-auto flex w-fit flex-col items-start gap-4">
                <div className="flex flex-col items-start justify-start gap-1.5">
                  <h2 className="text-foregound bg-[#D9D9D9] px-8 py-5 text-2xl font-bold uppercase sm:text-3xl lg:text-5xl">
                    {title_before_name}
                  </h2>
                  <h2 className="text-foregound bg-[#D9D9D9] px-8 py-5 text-2xl font-bold uppercase sm:text-3xl lg:text-5xl">
                    {member.name}, {title_after_name}
                  </h2>
                </div>
                <Button asChild className="h-fit py-4 sm:py-5">
                  <Link href={`/pravnici/${member.slug}`}>
                    <Heading
                      props={{
                        title: 'moje skúsenosti',
                        white: true,
                        className: { container: 'w-fit uppercase' },
                      }}
                    />
                    <GoArrowRight className="h-8 w-8 text-white sm:h-10 sm:w-10 lg:h-16 lg:w-16" />
                  </Link>
                </Button>
              </div>
            </div>
            <div
              className={cn(
                'absolute right-0 top-0 z-[3] h-full w-full opacity-50',
                'ea-team-member__overlay',
              )}
            />
            <div className="absolute inset-0 z-[2] h-full w-full bg-black/50" />
            <Image
              src={member?.image?.url ?? '/images/placeholder.png'}
              alt={resolveImageAlt(member?.image, member?.name)}
              fill
              style={{ objectFit: 'cover' }}
              className={cn('w-fill absolute inset-0 z-0 h-full object-cover object-top')}
              sizes="100vw"
              quality={100}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
